<template>
    <div>
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'User Management', to: { path: '/user-management' } },
                { text: 'Informasi User' },
            ]"
            divider=">"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">Ubah User Info</h3>

        <div>
            <v-card style="border">
                <!-- <v-card-title> -->
                <v-tabs>
                    <v-tab>Ubah User Info</v-tab>
                    <v-tab v-if="!isActive">Aktivasi User</v-tab>
                    <v-tab>Jadwal Kelas</v-tab>

                    <v-tab-item>
                        <v-card flat class="d-flex mt-5">
                            <v-col cols="3" class="py-0">
                                <v-card flat>
                                    <v-card-text>
                                        <!-- Image user preview -->
                                        <v-card
                                            flat
                                            class="border-bottom-divider rounded-tl px-2"
                                        >
                                            <a href="javascript:;">
                                                <v-img
                                                    aspect-ratio="1"
                                                    :src="
                                                        $store.state.usman
                                                            .picture
                                                    "
                                                />
                                            </a>
                                        </v-card>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col
                                cols="9"
                                style="border-left: 1px solid #f0f0f0"
                            >
                                <v-card flat>
                                    <!-- User items list -->
                                    <v-card-text class="pa-0">
                                        <v-list-item two-line>
                                            <v-list-item-content class="pa-0">
                                                <v-list-item-title
                                                    class="font-weight-bold pb-2"
                                                >
                                                    No Siswa
                                                </v-list-item-title>
                                                <v-text-field
                                                    id="user-student-number"
                                                    v-on:keypress="
                                                        /\d/.test(
                                                            String.fromCharCode(
                                                                $event.keyCode,
                                                            ),
                                                        ) ||
                                                        $event.keyCode == 45
                                                            ? true
                                                            : $event.preventDefault()
                                                    "
                                                    v-model="
                                                        data.student_number
                                                    "
                                                    placeholder="No. Siswa"
                                                    outlined
                                                />
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item two-line>
                                            <v-list-item-content class="pa-0">
                                                <v-list-item-title
                                                    class="font-weight-bold pb-2"
                                                >
                                                    Nama Siswa *
                                                </v-list-item-title>

                                                <v-text-field
                                                    id="user-name"
                                                    v-model="data.name"
                                                    placeholder="Nama Siswa"
                                                    outlined
                                                />
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item two-line>
                                            <v-list-item-content class="pa-0">
                                                <v-list-item-title
                                                    class="font-weight-bold pb-2"
                                                >
                                                    Email
                                                </v-list-item-title>
                                                <v-text-field
                                                    id="user-email"
                                                    disabled
                                                    v-model="data.email"
                                                    placeholder="Email"
                                                    outlined
                                                />
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item two-line>
                                            <v-list-item-content class="pa-0">
                                                <v-list-item-title
                                                    class="font-weight-bold pb-2"
                                                >
                                                    No.Telpon
                                                </v-list-item-title>
                                                <v-text-field
                                                    id="user-phone-number"
                                                    disabled
                                                    v-model="data.phone_number"
                                                    placeholder="No. Telpon"
                                                    :dense="
                                                        $vuetify.breakpoint
                                                            .smAndDown
                                                    "
                                                    outlined
                                                />
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item two-line>
                                            <v-list-item-content class="pa-0">
                                                <v-list-item-title
                                                    class="font-weight-bold pb-2"
                                                >
                                                    Sekolah
                                                </v-list-item-title>
                                                <v-text-field
                                                    id="user-school"
                                                    v-model="data.school"
                                                    placeholder="Sekolah"
                                                    outlined
                                                />
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item two-line>
                                            <v-list-item-content class="pa-0">
                                                <v-list-item-title
                                                    class="font-weight-bold pb-2"
                                                >
                                                    Kelas
                                                </v-list-item-title>
                                                <v-select
                                                    id="user-grade"
                                                    v-model="data.grade"
                                                    :items="[
                                                        {
                                                            text: '1 (SD)',
                                                            value: 1,
                                                        },
                                                        {
                                                            text: '2 (SD)',
                                                            value: 2,
                                                        },
                                                        {
                                                            text: '3 (SD)',
                                                            value: 3,
                                                        },
                                                        {
                                                            text: '4 (SD)',
                                                            value: 4,
                                                        },
                                                        {
                                                            text: '5 (SD)',
                                                            value: 5,
                                                        },
                                                        {
                                                            text: '6 (SD)',
                                                            value: 6,
                                                        },
                                                        {
                                                            text: '7 (SMP)',
                                                            value: 7,
                                                        },
                                                        {
                                                            text: '8 (SMP)',
                                                            value: 8,
                                                        },
                                                        {
                                                            text: '9 (SMP)',
                                                            value: 9,
                                                        },
                                                        {
                                                            text: '10 (SMA)',
                                                            value: 10,
                                                        },
                                                        {
                                                            text: '11 (SMA)',
                                                            value: 11,
                                                        },
                                                        {
                                                            text: '12 (SMA)',
                                                            value: 12,
                                                        },
                                                    ]"
                                                    outlined
                                                ></v-select>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item two-line>
                                            <v-list-item-content
                                                class="pt-0 px-0 pb-6"
                                            >
                                                <v-list-item-title
                                                    class="font-weight-bold pb-2"
                                                >
                                                    Status
                                                </v-list-item-title>
                                                <div>
                                                    <v-btn
                                                        disabled
                                                        v-if="
                                                            data.deactivate == 0
                                                        "
                                                        depressed
                                                        color="fade"
                                                    >
                                                        <span
                                                            class="dark--text"
                                                        >
                                                            Berakhir pada
                                                            {{
                                                                $moment(
                                                                    data.expired_at,
                                                                ).format(
                                                                    "MMM DD, YYYY",
                                                                )
                                                            }}
                                                        </span>
                                                    </v-btn>
                                                    <v-btn
                                                        id="user-deactivate-btn"
                                                        :block="false"
                                                        fab
                                                        depressed
                                                        min-width="21px"
                                                        width="21px"
                                                        min-height="21px"
                                                        height="21px"
                                                        color="redLight"
                                                        v-if="
                                                            data.deactivate == 0
                                                        "
                                                        @click="deactivate()"
                                                    >
                                                        <v-icon
                                                            small
                                                            color="white"
                                                            >mdi-close</v-icon
                                                        >
                                                    </v-btn>
                                                    <v-btn
                                                        :block="false"
                                                        v-else
                                                        disabled
                                                    >
                                                        Berakhir
                                                        {{ data.expired_at }}
                                                    </v-btn>
                                                </div>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item two-line>
                                            <v-list-item-content
                                                class="pt-0 px-0 pb-6"
                                            >
                                                <v-list-item-title
                                                    class="font-weight-bold pb-2"
                                                >
                                                    User Scope *
                                                </v-list-item-title>
                                                <v-row>
                                                    <v-col>
                                                        <v-select
                                                            :items="scopes"
                                                            item-text="name"
                                                            item-value="id"
                                                            class="select_scope"
                                                            hide-details
                                                            placeholder="-- Pilih user scope --"
                                                            outlined
                                                            v-for="(
                                                                fitur, i
                                                            ) in data.app_scope"
                                                            :key="i"
                                                            v-model="
                                                                data.app_scope[
                                                                    i
                                                                ]
                                                            "
                                                        >
                                                            <!-- <template v-slot:append-outer>
                                <v-btn
                                  id="user-remove-scope-btn"
                                  dark
                                  x-large
                                  class="font-weight-bold dark--text py-3"
                                  depressed
                                  color="white"
                                  elevation="1"
                                  v-if="
                                    i === data.app_scope.length - 1 &&
                                    data.app_scope.length != 1
                                  "
                                  @click="removeScope(i)"
                                >
                                  Hapus
                                </v-btn>
                              </template> -->
                                                        </v-select>
                                                    </v-col>
                                                    <v-col>
                                                        <v-menu
                                                            ref="menu"
                                                            v-for="(
                                                                fitur, i
                                                            ) in user_scope_expired_menu"
                                                            :key="i"
                                                            v-model="
                                                                user_scope_expired_menu[
                                                                    i
                                                                ].option
                                                            "
                                                            :close-on-content-click="
                                                                false
                                                            "
                                                            class="date_picker"
                                                            transition="slide-y-reverse-transition"
                                                            offset-y
                                                        >
                                                            <template
                                                                v-slot:activator="{
                                                                    on,
                                                                    attrs,
                                                                }"
                                                            >
                                                                <v-text-field
                                                                    v-model="
                                                                        user_scope_expired_menu[
                                                                            i
                                                                        ].value
                                                                    "
                                                                    append-icon="mdi-calendar"
                                                                    placeholder="Tanggal"
                                                                    readonly
                                                                    v-bind="
                                                                        attrs
                                                                    "
                                                                    v-on="on"
                                                                    outlined
                                                                ></v-text-field>
                                                            </template>
                                                            <v-date-picker
                                                                v-model="
                                                                    user_scope_expired_menu[
                                                                        i
                                                                    ].value
                                                                "
                                                                no-title
                                                                scrollable
                                                                @change="
                                                                    user_scope_expired_menu[
                                                                        i
                                                                    ].option =
                                                                        false
                                                                "
                                                            >
                                                            </v-date-picker>
                                                        </v-menu>
                                                    </v-col>
                                                </v-row>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-container>
                                            <v-btn
                                                id="user-add-scope-btn"
                                                @click="addScope()"
                                                block
                                                class="font-weight-bold dark--text"
                                                color="white"
                                            >
                                                <v-icon
                                                    style="
                                                        font-size: 16px !important;
                                                    "
                                                    >mdi-plus-circle</v-icon
                                                >
                                                Tambah Scope Baru
                                            </v-btn>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions class="pa-4">
                                        <v-spacer></v-spacer>
                                        <!-- Reset Data User Button -->
                                        <v-btn
                                            id="user-cancel-btn"
                                            depressed
                                            class="pa-2"
                                            @click="$router.go(-1)"
                                            >Batal</v-btn
                                        >

                                        <!-- Save Data User Button -->
                                        <v-btn
                                            id="user-save-btn"
                                            depressed
                                            class="px-6 py-2 white--text"
                                            color="blew"
                                            @click="editData()"
                                            >Simpan</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-col>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item v-if="!isActive">
                        <v-card class="mt-5">
                            <v-card-text class="pa-0">
                                <v-list-item two-line class="pa-0">
                                    <v-list-item-content class="ml-4">
                                        <!-- <v-list-item-title class="font-weight-bold pb-2">
                    </v-list-item-title> -->
                                        <v-radio-group row v-model="type">
                                            <v-radio
                                                id="non_nf_student"
                                                label="Siswa Non NF"
                                                value="non_nf_student"
                                                class="jenjang-selection"
                                                active-class="act-radio-btn"
                                            ></v-radio>
                                            <v-radio
                                                id="nf_student"
                                                label="Siswa NF"
                                                value="nf_student"
                                                class="jenjang-selection"
                                                active-class="act-radio-btn"
                                            ></v-radio>
                                        </v-radio-group>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item two-line>
                                    <v-list-item-content class="pa-0">
                                        <v-list-item-title
                                            class="font-weight-bold pb-2"
                                        >
                                            Email SIP
                                        </v-list-item-title>

                                        <v-text-field
                                            id="user-name"
                                            v-model="activation.email"
                                            placeholder="Email SIP"
                                            outlined
                                        />
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item
                                    two-line
                                    v-if="type === 'nf_student'"
                                >
                                    <v-list-item-content class="pa-0">
                                        <v-list-item-title
                                            class="font-weight-bold pb-2"
                                        >
                                            Nomor Induk
                                        </v-list-item-title>

                                        <v-text-field
                                            id="user-name"
                                            v-model="activation.nomorIndukNF"
                                            placeholder="Nomor Induk NF, 123-45-67890"
                                            outlined
                                        />
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item
                                    two-line
                                    v-if="type === 'non_nf_student'"
                                >
                                    <v-list-item-content class="pa-0">
                                        <v-list-item-title
                                            class="font-weight-bold pb-2"
                                        >
                                            Paket
                                        </v-list-item-title>
                                        <v-select
                                            id="user-grade"
                                            placeholder="Pilih paket"
                                            v-model="activation.package_id"
                                            :items="packageList"
                                            item-text="name"
                                            item-value="id"
                                            outlined
                                            v-on:change="
                                                getDetailPackage(
                                                    activation.package_id,
                                                )
                                            "
                                        ></v-select>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-card-text>

                            <v-card-actions class="pa-4">
                                <v-spacer></v-spacer>
                                <!-- Reset Data User Button -->
                                <v-btn
                                    id="user-cancel-btn"
                                    depressed
                                    class="pa-2"
                                    @click="$router.go(-1)"
                                    >Batal</v-btn
                                >

                                <!-- Save Data User Button -->
                                <v-btn
                                    id="user-save-btn"
                                    depressed
                                    v-if="type === 'non_nf_student'"
                                    class="px-6 py-2 white--text"
                                    color="blew"
                                    @click="activateUserGeneral()"
                                    >Simpan</v-btn
                                >

                                <v-btn
                                    id="user-save-btn"
                                    depressed
                                    v-if="type === 'nf_student'"
                                    class="px-6 py-2 white--text"
                                    color="blew"
                                    @click="activateUser()"
                                    >Simpan</v-btn
                                >
                            </v-card-actions>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card class="mt-5">
                            <v-card-text class="pa-0">
                                <v-list-item two-line>
                                    <v-list-item-content class="pa-0">
                                        <v-list-item-title
                                            class="font-weight-bold pb-2"
                                        >
                                            Jadwal Kelas
                                        </v-list-item-title>
                                        <v-select
                                            id="user-grade"
                                            placeholder="Pilih Jadwal"
                                            v-model="group_id"
                                            :items="package_groups"
                                            item-text="name"
                                            item-value="name"
                                            outlined
                                        ></v-select>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-card-text>

                            <v-card-actions class="pa-4">
                                <v-spacer></v-spacer>
                                <!-- Reset Data User Button -->
                                <v-btn
                                    id="user-cancel-btn"
                                    depressed
                                    class="pa-2"
                                    @click="$router.go(-1)"
                                    >Batal</v-btn
                                >

                                <!-- Save Data User Button -->
                                <v-btn
                                    id="user-save-btn"
                                    depressed
                                    class="px-6 py-2 white--text"
                                    color="blew"
                                    @click="editSchedule()"
                                    >Simpan</v-btn
                                >
                            </v-card-actions>
                        </v-card>
                    </v-tab-item>
                </v-tabs>
                <v-divider />
            </v-card>
        </div>
    </div>
</template>

<script>
import AccountService from "@/modules/auth/services/auth.js";
import axios from "axios";
import moment from "moment";
import SalesService from "@/modules/global/services/sales.js";
import Spinner from "@/modules/global/components/plugins/Spinner";
import TryoutService from "@/modules/tryout/services/tryout.js";

export default {
    name: "user-form",

    components: {
        "app-spinner": Spinner,
    },

    data: function () {
        return {
            tab: 1,
            isLoading: false,
            type: "non_nf_student",
            activation: {
                email: null,
                nomorIndukNF: null,
                package_id: null,
                group_id: null,
                type: null,
                consul_session: null,
                grade: null,
                app_scopes: [],
            },
            packageList: [],
            data: {
                name: null,
                student_number: null,
                email: null,
                phone_number: null,
                school: null,
                grade: null,
                group_schedule: null,
                class: null,
                expired_at: null,
                deactivate: null,
                app_scope: [],
                scope_choose: [],
                user_scopes_expired: [],
            },
            user_scope_expired_menu: [],
            package_groups: [],
            group_id: null,
            scopes: [],
            detail: {},
        };
    },

    computed: {
        // Check expiredAt User Premium has not passed
        isActive: function () {
            var now = new moment();
            var expiredAt = new moment(
                this.$store.state.usman.expired_at,
                "YYYY-MM-DD",
            );
            var diff = expiredAt.valueOf() - now.valueOf();
            if (diff > 0) {
                this.data.deactivate = 0;
                return true;
            } else {
                return false;
            }
        },
    },

    methods: {
        // Get all list data user scope
        getDataDetail: function () {
            var context = this;
            var token = this.$ls.get("token");
            var user_id = this.$store.state.usman.user_id;

            var url =
                process.env.API_BASE_URL + `account/usman/${user_id}/user`;

            var http = axios.create({
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                },
            });

            http.get(url)
                .then(function (response) {
                    context.detail = response.data;
                    context.data.user_scopes_expired =
                        response.data.user_scopes_expired;

                    context.data.user_scopes_expired.forEach(function (data) {
                        var timedate = new Date(data);
                        console.log(timedate);
                        var menu = {
                            option: false,
                            value: moment(timedate).format("YYYY-MM-DD"),
                        };

                        context.user_scope_expired_menu.push(menu);
                    });
                    var data_scopes = response.data.user_app_scopes;
                    data_scopes.map((res) => {
                        context.data.app_scope.push(res.app_scope_id.id);
                    });
                })
                .catch(function (error) {
                    console.log(error.message);
                })
                .then(function () {
                    context.isLoading = false;
                });
        },
        // Get all list data user scope
        getScopeList: function () {
            var context = this;
            var token = this.$ls.get("token");
            var url = process.env.API_BASE_URL + "account/appscopes/getlist";

            var http = axios.create({
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                },
            });

            http.get(url)
                .then(function (response) {
                    context.scopes = response.data;
                    context.scopes = _.orderBy(
                        context.scopes,
                        ["name"],
                        ["asc"],
                    );
                })
                .catch(function (error) {
                    console.log(error.message);
                })
                .then(function () {
                    context.isLoading = false;
                });
        },

        // Joining data Detail User Management with data Jadwal Kelas by group_schedule
        getJadwalKelas: function () {
            if (!this.data.group_schedule) {
                return false;
            }
            if (this.data.class) {
                return true;
            }

            var context = this;
            var token = this.$ls.get("token");
            var url =
                process.env.API_BASE_URL +
                "payment/package/group/" +
                this.data.group_schedule +
                "/detail";

            var http = axios.create({
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                },
            });

            http.get(url)
                .then(function (response) {
                    context.data.class = response.data;
                })
                .catch(function (error) {
                    console.log(error.message);
                })
                .then(function () {
                    context.isLoading = false;
                });
        },

        getListPackage: function () {
            var context = this;

            this.isLoading = true;
            SalesService.getPaket(function (result) {
                context.packageList = [];

                if (result.success) {
                    result.data.forEach(function (content) {
                        var row = {
                            id: content.id,
                            name: content.name,
                        };

                        context.packageList.push(row);
                        context.packageList = _.orderBy(
                            context.packageList,
                            ["name"],
                            ["asc"],
                        );
                    });
                    context.isLoading = false;
                }
            });
        },

        // Get User Detail data
        loadDetailData: function () {
            // check membership
            var context = this;
            var token = this.$ls.get("token");
            if (!this.$store.state.usman.user_id)
                this.$router.replace({ name: "UserManagement" });
            var url = process.env.API_BASE_URL + "/tryout-service/membership";

            this.isLoading = true;
            var http = axios.create({
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                },
            });

            http.get(url, {
                params: {
                    email: context.$store.state.usman.email,
                },
            })
                .then(function (response) {
                    context.memberships = response.data;
                })
                .catch(function (error) {
                    console.log(error.message);
                })
                .then(function () {
                    context.isLoading = false;
                });
        },

        // Change expired_at to todays date for forced deactive premium
        deactivate: function () {
            if (this.data.deactivate == 0) {
                const today = new Date();
                const date = moment().format("YYYY-MM-DD");
                this.data.expired_at = date;
                this.data.deactivate = 1;
            } else {
                this.data.deactivate = 0;
            }
        },

        // Change Date Format from millisecond
        displayTimestamp: function (timeInMilis) {
            if (!timeInMilis) return "-";
            return moment(timeInMilis).format("D MMM YYYY HH:mm");
        },

        getItemCount: function (tryout) {
            var total = 0;
            tryout.subtests.forEach(function (subtest) {
                total += subtest.item_count;
            });

            return total;
        },

        // Activation User Premium
        activateUser: function () {
            var userId = this.$store.state.usman.user_id;
            var cleanString = this.activation.nomorIndukNF.replace(/-/g, "");
            var formattedNoInduk = this.activation.nomorIndukNF;

            if (cleanString.length === 10) {
                formattedNoInduk =
                    cleanString.substring(0, 3) +
                    "-" +
                    cleanString.substring(3, 5) +
                    "-" +
                    cleanString.substring(5);
            }

            this.isLoading = true;
            var context = this;
            AccountService.userActivation(
                userId,
                this.activation.email,
                formattedNoInduk,
                function (response) {
                    if (response.success) {
                        var userData = response.data;
                        context.$store.commit("usman_init", userData);
                        context.data.user_id =
                            context.$store.state.usman.user_id;
                        context.data.picture =
                            context.$store.state.usman.picture;
                        context.data.name = response.data.name;
                        context.data.student_number =
                            response.data.student_number;
                        context.data.email = response.data.email;
                        context.data.phone_number = response.data.phone_number;
                        context.data.school = response.data.school;
                        context.data.grade = response.data.grade;
                        context.data.expired_at = response.data.expired_at;
                        context.data.user_app_scopes =
                            response.data.user_app_scopes;
                        context.data.user_scopes_expired =
                            response.data.user_scopes_expired;
                        context.$store.commit("showAlert", {
                            message: `Aktivasi user telah berhasil!`,
                            type: "success",
                        });
                    } else {
                        context.$store.commit("showAlert", {
                            message: `Gagal melakukan aktivasi user!`,
                            type: "error",
                        });
                    }

                    context.isLoading = false;
                },
            );
        },

        getDetailPackage(id) {
            var context = this;
            var grup = [];

            SalesService.getDetailPaket(id, function (result) {
                if (result.success) {
                    context.activation.app_scopes =
                        result.data.package_app_scope;
                    context.activation.group_id = result.data.user_group_id;
                    context.activation.type = result.data.type;
                    context.activation.consul_session =
                        result.data.consul_session;
                    result.data.package_group.forEach((element) => {
                        const datas = {
                            id: element.id,
                            name: element.description,
                        };
                        grup.push(datas);
                    });
                    context.package_groups = grup;
                }
            });
        },

        activateUserGeneral() {
            this.isLoading = true;
            this.activation.grade = this.$store.state.usman.grade;
            var context = this;

            var packageData = {
                user_id: context.$store.state.usman.user_id,
                package_id: context.activation.package_id,
            };

            AccountService.userActivationGeneral(
                context.activation,
                function (response) {
                    if (response.success) {
                        if (response.data.status === "200") {
                            context.$store.commit("package_init", packageData);
                            context.$store.commit("showAlert", {
                                message: `Aktivasi user telah berhasil!`,
                                type: "success",
                            });
                            context.$router.push("user-management");
                        } else {
                            context.$store.commit("showAlert", {
                                message: `Gagal melakukan aktivasi user!`,
                                type: "error",
                            });
                        }
                    } else {
                        context.$store.commit("showAlert", {
                            message: `Gagal melakukan aktivasi user!`,
                            type: "error",
                        });
                    }

                    context.isLoading = false;
                },
            );
        },

        resetState: function (bundle_code, email) {
            var body = {
                bundle_code: bundle_code,
                email: email,
            };

            var context = this;
            TryoutService.resetStateTryout(body, function (result) {
                if (result.success) {
                    context.loadDetailData();
                    context.$store.commit("showAlert", {
                        message: `Berhasil mereset status!`,
                        type: "success",
                    });
                } else {
                    context.$store.commit("showAlert", {
                        message: `Gagal mereset status!`,
                        type: "error",
                    });
                }
            });
        },

        editSchedule() {
            var body = {
                id: this.$store.state.usman.user_id,
                group_id: this.group_id,
            };

            var context = this;
            AccountService.changeSchedule(body, function (result) {
                if (result.success) {
                    context.$store.commit("showAlert", {
                        message: `Berhasil mengubah jadwal!`,
                        type: "success",
                    });
                } else {
                    context.$store.commit("showAlert", {
                        message: `Gagal mengubah jadwal!`,
                        type: "error",
                    });
                }
            });
        },

        // Update User
        editData: function () {
            console.log(this.data.app_scope);
            if (this.data.name == "") {
                this.$store.commit("showAlert", {
                    message: `Nama wajib diisi!`,
                    type: "error",
                });
                return true;
            }

            var context = this;
            var userId = this.$store.state.usman.user_id;
            var token = this.$ls.get("token");
            var url =
                process.env.API_BASE_URL +
                "account/usman/admin/update/" +
                userId +
                "/users";

            this.isLoading = true;
            var http = axios.create({
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                },
            });

            var param = {};
            param.student_name = this.data.name;
            param.student_number =
                this.data.student_number == ""
                    ? null
                    : this.data.student_number;
            param.phone_number = this.data.phone_number;
            param.student_school = this.data.school;
            param.grade = this.data.grade;
            param.deactivate = this.data.deactivate;
            param.expired_at = Math.round(
                new Date(this.data.expired_at).getTime(),
            );
            param.user_app_scopes = this.data.app_scope;
            context.data.user_scopes_expired = [];
            context.user_scope_expired_menu.forEach(function (data) {
                var timedate = Date.parse(data.value);

                context.data.user_scopes_expired.push(timedate);
            });
            param.user_scopes_expired = this.data.user_scopes_expired;

            http.put(url, param)
                .then(function (response) {
                    context.data.user_id = context.$store.state.usman.user_id;
                    context.data.picture = context.$store.state.usman.picture;
                    context.data.name = response.data.name;
                    context.data.student_number = response.data.student_number;
                    context.data.email = response.data.email;
                    context.data.phone_number = response.data.phone_number;
                    context.data.school = response.data.school;
                    context.data.grade = response.data.grade;
                    context.data.expired_at = response.data.expired_at;
                    context.data.user_app_scopes =
                        response.data.user_app_scopes;
                    context.data.user_scopes_expired =
                        response.data.user_scopes_expired;
                    context.$store.commit("usman_init", context.data);
                    context.$router.push("user-detail");
                    context.$store.commit("showAlert", {
                        message: `Update data user telah berhasil!`,
                        type: "success",
                    });
                })
                .catch(function (error) {
                    context.$store.commit("showAlert", {
                        message: `Error!`,
                        submessage: error.message,
                        type: "error",
                    });
                })
                .then(function () {
                    context.isLoading = false;
                });
        },

        // Check admin permission and load user data choosen
        isUpdate: function () {
            let answer = false;
            const token = JSON.parse(localStorage.token).value;
            const base64Url = token.split(".")[1];
            const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
            const jsonPayload = decodeURIComponent(
                atob(base64)
                    .split("")
                    .map(
                        (c) =>
                            `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`,
                    )
                    .join(""),
            );

            if (this.$store.state.usman.is_nf_student) {
                this.type = "nf_student";
            } else {
                this.type = "non_nf_student";
            }

            const decoded = JSON.parse(jsonPayload);
            for (let scope in decoded.user_scopes) {
                if (
                    decoded.user_scopes[scope] === "write_userman" ||
                    decoded.user_scopes[scope] === "write_appscope"
                ) {
                    answer = true;
                    this.data.name = this.$store.state.usman.name;
                    this.data.student_number =
                        this.$store.state.usman.student_number == "-"
                            ? null
                            : this.$store.state.usman.student_number;
                    this.activation.nomorIndukNF =
                        this.$store.state.usman.student_number == "-"
                            ? null
                            : this.$store.state.usman.student_number;
                    this.data.email = this.$store.state.usman.email;
                    this.activation.email = this.$store.state.usman.email;
                    this.data.phone_number =
                        this.$store.state.usman.phone_number;
                    this.data.school = this.$store.state.usman.school;
                    this.data.grade = this.$store.state.usman.grade;
                    this.data.expired_at = this.$store.state.usman.expired_at;
                    // this.data.app_scope = this.$store.state.usman.user_scopes_id;
                    this.data.group_schedule =
                        this.$store.state.usman.group_schedule;
                    this.data.group_schedule =
                        this.$store.state.usman.group_schedule;
                    this.data.user_scopes_expired =
                        this.$store.state.usman.user_scopes_expired;
                    var now = new moment();
                    var expiredAt = new moment(
                        this.$store.state.usman.expired_at,
                        "YYYY-MM-DD",
                    );
                    var diff = expiredAt.valueOf() - now.valueOf();
                    if (diff > 0) {
                        this.data.deactivate = 0;
                    } else {
                        this.data.deactivate = 1;
                    }

                    // var data_scopes = this.$store.state.usman.user_app_scopes;
                    // this.data.app_scope = [];
                    // data_scopes.map((res) => {
                    //   this.data.app_scope.push(res.app_scope_id.id);
                    // });

                    // this.getJadwalKelas();
                }
            }
            return answer;
        },

        removeScope(i) {
            this.data.app_scope.splice(i, 1);
            this.data.user_scopes_expired.splice(i, 1);
        },

        addScope() {
            var menu = {
                option: false,
                value: null,
            };
            this.data.app_scope.push("");
            this.user_scope_expired_menu.push(menu);
        },
    },

    mounted: function () {
        this.getDataDetail();
        this.loadDetailData();
        this.getScopeList();
        this.isUpdate();
        this.getListPackage();
        if (this.isActive) {
            this.group_id = this.$store.state.usman.group_schedule;
            this.getDetailPackage(this.$store.state.usman.package_id);
        }
    },
};
</script>

<style scoped>
.text-subtitle-1 {
    font-family: Ubuntu !important;
}

.date_picker >>> .v-input__slot {
    min-height: 80px !important;
    margin-bottom: 0px;
}

.date_picker >>> .v-input__slot > .v-text-field {
    padding: 0;
    margin-bottom: 0px;
}

.select_scope {
    padding-bottom: 9px;
    margin-bottom: 21px;
}
</style>



// WEBPACK FOOTER //
// UserManagementForm.vue?306d8e57